import { render } from "./roles.vue?vue&type=template&id=8392ca96"
import script from "./roles.vue?vue&type=script&lang=js"
export * from "./roles.vue?vue&type=script&lang=js"
script.render = render

export default script